import React, { useState } from "react";
import PropTypes from "prop-types";
import { MealPlannerHeader } from "./components/MealPlannerHeader";
import MealPlannerTabs from "./components/MealPlannerTabs";
import { MealPlannerOptionResume } from "./components/MealPlannerOptionResume";
import MealClipboardContent from "../../../../parts/MealClipboardContent";

/**
 * SimplifiedMealPlanner
 *
 * Main component for simplified meal plans
 * Uses trainingDayOptions and restDayOptions instead of weeks
 *
 * NOTE: For simplified meal plan templates, only trainingDayOptions is used.
 * The tabs (Training Day / Rest Day) are hidden for templates, and tabState
 * is always "training" so only trainingDayOptions[0] is edited.
 */
export const SimplifiedMealPlanner = ({ locals, planMode, api }) => {
  const { mealPlan } = locals;
  // Always initialize to "training" - for templates, tabs are hidden so this can't change
  const [tabState, setTabState] = useState("training");
  return (
    <main role="nutrition-wrapper" className="Nutrition meal-planner-main">
      <MealPlannerHeader
        mealPlan={mealPlan}
        locals={locals}
        planMode={planMode}
      />
      <MealPlannerTabs
        mealPlan={mealPlan}
        locals={locals}
        tabState={tabState}
        setTabState={setTabState}
        planMode={planMode}
      />
      <MealPlannerOptionResume
        mealPlan={mealPlan}
        locals={locals}
        tabState={tabState}
        planMode={planMode}
        api={api}
      />
      <MealClipboardContent
        query={locals.query?.mealsInClipboard}
        locals={locals}
      />
    </main>
  );
};

SimplifiedMealPlanner.propTypes = {
  locals: PropTypes.object,
  planMode: PropTypes.string,
};
